export default "__VITE_ASSET__uz6l1eDU__"